import { render, staticRenderFns } from "./FcfMain.vue?vue&type=template&id=4a3705b4&scoped=true&"
import script from "./FcfMain.vue?vue&type=script&lang=js&"
export * from "./FcfMain.vue?vue&type=script&lang=js&"
import style0 from "./FcfMain.vue?vue&type=style&index=0&id=4a3705b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3705b4",
  null
  
)

export default component.exports